import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemsToSellRoutingModule } from './items-to-sell-routing.module';
import { DeleteItemConfirmationDialog, ItemPickerComponent } from './components/item-picker/item-picker.component';
import { ItemsToSellPageComponent } from './components/page/items-to-sell-page.component';
import { MatButtonModule } from '@angular/material/button';

import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from '../shared/shared.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { ItemTileModule } from '../shared/item-tile/item-tile.module';
import { ItemListModule } from '../shared/item-list/item-list.module';
import { ScanGMailButtonModule } from '../shared/scan-gmail-button/scan-gmail-button.module';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
	  ItemPickerComponent,
	  ItemsToSellPageComponent,
	  DeleteItemConfirmationDialog
  ],
  imports: [
    CommonModule,
    SharedModule,
    ItemsToSellRoutingModule,
    MatListModule,
    MatButtonModule,
    MatCardModule,
    MatGridListModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    ItemTileModule,
    ItemListModule,
    MatSlideToggleModule,
    ScanGMailButtonModule,
    MatTooltipModule
  ],
})
export class ItemsToSellModule { }
